var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24147_34713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.94266V0.351192L12.6434 2.19746C11.1753 0.740011 9.47009 0 7.53027 0C3.65568 0 0.5 3.14316 0.5 7.00126C0.5 10.8593 3.65568 14 7.53279 14C10.2294 14 13.4405 12.6028 14.3663 8.68196L14.384 8.6067H12.3483L12.3357 8.64935C11.6571 10.6812 9.72486 12.0484 7.53532 12.0484C6.18829 12.0509 4.89676 11.5191 3.94577 10.5684C2.99225 9.62516 2.45495 8.3408 2.46 7.00126C2.46 4.21932 4.73784 1.95413 7.53532 1.95413C8.83946 1.95413 9.83081 2.31786 11.2712 3.5671L8.87982 5.94266H14.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24147_34713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.831a54c73b1bc9f083fcbb4dafba83be.svg";
export { ForwardRef as ReactComponent };